export default function formatPhone(phoneNumber) {
  if (!phoneNumber) {
    return null;
  }

  const cleaned = phoneNumber?.replace(/\D/g, '');

  const withoutCountryCode = cleaned?.startsWith('55')
    ? cleaned.slice(2)
    : cleaned;

  const digits = withoutCountryCode?.slice(0, 11);

  if (digits.length <= 10) {
    return digits?.replace(/^(\d{2})(\d{4})(\d{0,4})$/, '($1) $2-$3');
  }

  return digits?.replace(/^(\d{2})(\d{5})(\d{0,4})$/, '($1) $2-$3');
}
